import React, { useState } from "react";
import { ChevronDown, ChevronUp, Download } from "lucide-react";
import "./CurriculumSection.css";

const curriculumData = [
  {
    module: "Module 1: Introduction & Basics",
    topics: [
      "Course overview & expectations",
      "Fundamental concepts",
      "Getting started with tools"
    ]
  },
  {
    module: "Module 2: Intermediate Concepts",
    topics: [
      "Deep dive into subject core",
      "Hands-on assignments",
      "Case studies & real examples"
    ]
  },
  {
    module: "Module 3: Advanced Applications",
    topics: [
      "Expert techniques",
      "Project-based learning",
      "Exam preparation strategies"
    ]
  }
];

export default function CurriculumSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleModule = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="curriculam-section-container">
      <div className="curriculam-section-header">
        <h2 className="curriculam-section-title">Course Curriculum</h2>
        <p className="curriculam-section-subtitle">
          Explore the complete breakdown of modules and topics included in this course.
        </p>
      </div>

      <div className="curriculam-section-modules">
        {curriculumData.map((module, index) => (
          <div
            key={index}
            className={`curriculam-section-module ${
              openIndex === index ? "curriculam-section-module-open" : ""
            }`}
          >
            <div
              className="curriculam-section-module-header"
              onClick={() => toggleModule(index)}
            >
              <span className="curriculam-section-module-title">
                {module.module}
              </span>
              {openIndex === index ? (
                <ChevronUp size={20} />
              ) : (
                <ChevronDown size={20} />
              )}
            </div>
            {openIndex === index && (
              <ul className="curriculam-section-topic-list">
                {module.topics.map((topic, tIndex) => (
                  <li key={tIndex} className="curriculam-section-topic-item">
                    {topic}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      <div className="curriculam-section-download">
        <a
          href="/syllabus.pdf"
          download
          className="curriculam-section-download-btn"
        >
          <Download size={18} />
          Download Full Syllabus
        </a>
      </div>
    </section>
  );
}
